import { useSettings } from '@/hooks/state/useSettings';
import { normalizeIsoCountry } from '@/lib/geo/country';
import { taxExclusiveNote } from '@/lib/pricing/businessPlans';
import { usePricingCohortInitial } from '@/lib/pricing-test';

/** Same country resolution as `usePricingCohort`: settings, then the pricing page's SSR geo. */
export const useTaxExclusiveNote = (): string => {
  const { settings } = useSettings();
  const initial = usePricingCohortInitial();

  return taxExclusiveNote(
    normalizeIsoCountry(settings?.country?.iso_code_2) ||
      initial?.initialCountry
  );
};
